import { http } from "../utils/http";

export const inspectDownload = (data) =>
  http.get("/weilan/api/inspect/download", data);
export const getInspect = (data) =>
  http.get("/weilan/api/inspect/inspect", data);
export const inspectUpload = (data) =>
  http.post("/weilan/api/inspect/upload", data);
